<template>
  <loading-cube v-if="isLoading" />
  <div v-else>
    <div class="fullscreen-modal__content">
      <page>
        <page-title>
          {{ $t('c.contentExportOverlay.stepOutput.title') }}
        </page-title>

        <text-input
          v-if="response"
          :is-copyable="true"
          :is-disabled="true"
          :value="response.url"
          direction="vertical"
          label="Export URL"
          name="exportUrl"
        >
          <a
            slot="addon"
            :href="response.url"
            target="_blank"
          >
            In neuem Fenster öffnen
          </a>
        </text-input>
      </page>
    </div>

    <div class="fullscreen-modal__footer">
      <div class="container">
        <div class="row">
          <div class="col-xs-6 col-lg-4 push-lg-2">
            <button-input
              v-t="'c.contentExportOverlay.stepOutput.btnClose'"
              @click="close"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import isBlank from 'is-blank'
import PageMixin from '@/mixins/pages/Page'
import FormMixin from '@/mixins/forms/Form'
import LoadingCube from '@/components/ui/LoadingCube'

export default {
  name: 'ContentExpoerStepOutput',

  mixins: [PageMixin, FormMixin],

  components: {
    LoadingCube
  },

  data() {
    return {
      response: null
    }
  },

  computed: {
    ...mapState({
      isLoading: state => state.contentExport.request.isLoading,
      folder: state => state.folder.folder,
      format: state => state.contentExport.form.format,
      selected: state => state.contentExport.articlesSelected
    }),

    title () {
      if (isBlank(this.folder)) {
        return ''
      }

      return isBlank(this.folder.alternativeName)
        ? this.folder.name
        : this.folder.alternativeName
    }
  },

  methods: {
    ...mapActions ({
      export: 'contentExport/export',
      close: 'openFullscreenModal',
    })
  },

  created () {
    this.export({
      title: this.title,
      format: this.format,
      contentIds: this.selected
    })
      .then((response) => {
        this.response = response
      })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/export/steps/Output.vue